import { MapPin } from "lucide-react";
import useRegions from "@/hooks/useRegions";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/**
 * Compact "Filter by region" dropdown for list toolbars.
 *
 *   <RegionFilter value={filter} onChange={setFilter} />
 *
 * Value is "" (All), "__none__" (records without a region), or a region id.
 */
export default function RegionFilter({ value, onChange, testId = "region-filter", includeUnassigned = true, className = "" }) {
  const { regions } = useRegions();
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <MapPin className="w-3.5 h-3.5 text-slate-400 shrink-0" />
      <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
        <SelectTrigger data-testid={testId} className="h-9 min-w-[10rem] text-xs">
          <SelectValue placeholder="All regions" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All regions</SelectItem>
          {regions.map((r) => (
            <SelectItem key={r.id} value={r.id} data-testid={`${testId}-option-${r.id}`}>
              {r.name}
            </SelectItem>
          ))}
          {includeUnassigned && (
            <SelectItem value="__none__" data-testid={`${testId}-option-none`}>
              — No region
            </SelectItem>
          )}
        </SelectContent>
      </Select>
    </div>
  );
}
